<div>
  <mat-label class="font-semibold">{{label}}</mat-label>
  <div>{{ value }}</div>
</div>
